import { Box } from "@chakra-ui/react";
import { Spacing, customEvent } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { useRouter } from "next/router";
import React from "react";
import ContentFilterSection from "./components/ContentFilterSection";
import ContentSeriesSection from "./components/ContentSeriesSection";
import ContentAllSection from "./components/ContentAllSection";
import ContentFaqSection from "./components/ContentFaqSection";
import ContentArticleCard from "./components/ContentArticleCard";
import ContentVideoCard from "./components/ContentVideoCard";
import { CONTENT_DATA, FilterKey, SERIES } from "./constants/contentData";
import { RenewalFooter } from "goi_common/src/components/RenewalFooter";

const FILTER_KEYS = new Set<FilterKey>([
  "100won",
  "good_sangjo",
  "funeral_prep",
  "funeral_now",
]);

function isFilterKey(value: string | string[] | undefined): value is FilterKey {
  return typeof value === "string" && FILTER_KEYS.has(value as FilterKey);
}

export default function ContentMainContainer() {
  const router = useRouter();
  const selectedFilter = isFilterKey(router.query.filter)
    ? router.query.filter
    : null;

  const handleFilterSelect = (key: FilterKey | null) => {
    if (key === null) {
      router.replace({ pathname: "/content" }, undefined, { shallow: true });
    } else {
      router.replace({ query: { filter: key } }, undefined, { shallow: true });
    }
  };

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      minHeight="100vh"
      background="#ffffff"
    >
      <Box width="100%" maxWidth="480px">
        <ContentFilterSection
          selectedFilter={selectedFilter}
          onSelect={handleFilterSelect}
        />

        {selectedFilter === null ? (
          <>
            {SERIES.map((series, index) => (
              <React.Fragment key={series.key}>
                <ContentSeriesSection series={series} />
                {index < SERIES.length - 1 && (
                  <Box width="100%" height="12px" background="#f4f5f6" />
                )}
              </React.Fragment>
            ))}

            <Box width="100%" height="1px" background="#e8e9ea" />

            <ContentAllSection />

            <Box width="100%" height="1px" background="#e8e9ea" />

            <ContentFaqSection />
          </>
        ) : (
          <>
            <Spacing gap={24} />
            <BaseStack px={20} width="100%">
              {CONTENT_DATA[selectedFilter].map((item, index) => (
                <React.Fragment key={item.id}>
                  {index > 0 && <Spacing gap={24} />}
                  {item.type === "article" && (
                    <ContentArticleCard item={item} />
                  )}
                  {item.type === "video" && <ContentVideoCard item={item} />}
                </React.Fragment>
              ))}
            </BaseStack>

            <Spacing gap={32} />

            <Box px="20px" width="100%">
              <Box
                as="button"
                width="100%"
                style={{
                  padding: "14px 0",
                  border: "1px solid #dddedf",
                  borderRadius: "6px",
                  background: "#ffffff",
                  color: "#46494c",
                  fontSize: "15px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  letterSpacing: "-0.3px",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: "content",
                      trigger_and_target: "btn_all_content",
                    },
                  });
                  handleFilterSelect(null);
                }}
              >
                고이 컨텐츠 전체 보기
              </Box>
            </Box>

            <Spacing gap={40} />
          </>
        )}
      </Box>

      <RenewalFooter />
    </Box>
  );
}
